import React from 'react';
import { node, object } from 'prop-types';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import propulsionTheme from './index';
function ThemeProvider({
  children,
  theme
}) {
  return /*#__PURE__*/React.createElement(MuiThemeProvider, {
    theme: theme
  }, children);
}
ThemeProvider.defaultProps = {
  theme: propulsionTheme
};
ThemeProvider.propTypes = {
  /** The root component that will use Propulsion components in its tree. */
  children: node.isRequired,
  /** The Propulsion theme in case you want to override it, it will use the default one if not provided. */
  theme: object
};
export default ThemeProvider;